module.exports = __webpack_public_path__ + "media/images/top/review-sample04-dde7f2adce5b6bdb5b6c8be1ca530677.jpg";